import type { InternalNotesNotifySelection } from '../types'
import type { DefaultApiPage, NotesFor } from './residentDecoupling'

export function isInternalNotesNotifySelectionValid(
  selection: InternalNotesNotifySelection,
): boolean {
  return Boolean(selection.email_sendto?.trim())
}

/** Maps dialog `email_sendto` to Angular `sendReviewUpdate` `message_send_to`. */
export function internalNotesMessageSendTo(emailSendTo: string | undefined): string | null {
  const map: Record<string, string> = {
    default_manager: 'default_mgr',
    success_manager: 'client_success',
    default_success: 'default_success',
    customer_service: 'customer_service',
  }
  if (!emailSendTo) return null
  return map[emailSendTo] ?? null
}

export function isInternalNotesOnlySave(emailSendTo: string | undefined): boolean {
  return emailSendTo === 'none' || emailSendTo === 'l1_review'
}

/**
 * POST `page` for Liberty Internal notify (`message_insurance` + `message_send_to`).
 * 3.0: aligns with `notes_for` / GET `insurance_message` (`RESIDENT_INSURANCE` vs `DEFAULT_INSURANCE`).
 * Backend runs full notify + email on both pages (lifecycle handler for `resident`, claim handler for `default`).
 */
export function apiPageForInternalInsuranceMessage(notesFor: NotesFor): DefaultApiPage {
  return notesFor === 'DEFAULT' ? 'default' : 'resident'
}

export type { InternalNotesNotifySelection } from '../types'

